<template>
    <div id="login">
        <div class="content" :class="{active:showImg}">
            <a-icon type="close" class="close" @click="onClose"/>
            <a-form class="form" :form="form" @submit="handleSubmit">
                <a-form-item label="手机号码" :label-col="{ span: 7 }" :wrapper-col="{ span: 12 }">
                    <a-input
                        v-decorator="['phone', { rules: [{ required: true, message: '请输入你的手机号码!' }] }]"
                    />
                </a-form-item>
                <a-form-item class="password-row" label="密码" :label-col="{ span: 7 }" :wrapper-col="{ span: 12 }">
                    <a-input
                        v-decorator="['password', { rules: [{ required: true, message: '请输入你的账号密码!' }] }]"
                        type="password"
                    />
                </a-form-item>
                <a-checkbox v-if="showImg" class="save-me" v-model="saveMe">记住密码</a-checkbox>
                <img 
                    v-if="showImg" 
                    :src="showImg" 
                    class="uuid-img"
                />
                <a-form-item :wrapper-col="{ span: 24, offset: 7 }">
                    <a-button type="primary" html-type="submit" >
                        {{showImg ? "刷新二维码" : "获取二维码"}}
                    </a-button>
                    <a-button v-if="showImg" type="primary" @click="getWxCode" style="margin-left:40px;">
                        我已扫码
                    </a-button>
                </a-form-item>
                <p v-show="showImg" class="tips">
                    请使用“天蓝卫士”小程序扫码(个人信息->扫码授权网页版登录)。
                </p>
            </a-form>
        </div>
    </div>
</template>

<script>
import UrlApi from "@/utils/UrlApi.js";
import Cookies from 'js-cookie'
import Mixins from "@/utils/Mixins.js";
export default {
    name:"Login",
    mixins:[Mixins],
    data () {
        return {
            form: this.$form.createForm(this, { name: 'coordinated' }),
            showImg: false,
            params:{
                phone: null,
                password: null,
                wxCode: null,
                wxCodeUrl:null
            },
            saveMe:true
        };
    },
    mounted(){
        let savePassword = Cookies.get("BSG-savePassword");
        if(savePassword){
            let {phone,password} = JSON.parse(savePassword);
            this.params.phone = phone;
            this.params.password = password;
            this.form.setFieldsValue({
                phone:phone,
                password:password
            })
            this.saveMe = true;
        }
    },
    methods: {
        onClose(){
            this.$emit('update:showLogin',false)
        },
        handleSubmit(e){
            // let url = UrlApi.loginUrl;
            e.preventDefault();
            this.form.validateFields((err, values) => {
                if (!err) {
                    this.params.phone = values.phone;
                    this.params.password = values.password;
                    this.getUuidAndImg();
                }
            });
            return
        },
        // 获取uuid和二维码
        getUuidAndImg(){
            let url = UrlApi.qrCode;
            this.showImg = url;
            this.$http.get(url).then((res)=>{
                this.showImg = res.data.data.jpgBase64;
                let wxCodeUrl = res.data.data.wxCodeGetUrl;
                this.params.wxCodeUrl = wxCodeUrl;
            })
        },
        // 获取微信授权码
        getWxCode(showMessage){
            let url = this.params.wxCodeUrl;
            this.$http.get(url).then((res)=>{
                let state = res.data.success;
                if(state){
                    this.params.wxCode = res.data.data;
                    this.login();
                    return;
                }
                // 点击我已扫码时候显示
                if(showMessage){
                    this.$message.warning(res.data.message);
                    this.getUuidAndImg();
                }
            })
        },
        // 登录
        login(){
            let url = UrlApi.loginUrl;
            let param = `phone=${this.params.phone}&password=${this.params.password}&wxCode=${this.params.wxCode}`
            this.$http.post(url,param,{
                headers:{
                    "Content-Type":"application/x-www-form-urlencoded"
                }
            }).then((res)=>{
                this.$message.success(res.data.message);
                if(res.data.success){
                    let userId = res.data.data.userInfo.userId;
                    let token = res.data.data.token;
                    let userName = res.data.data.userInfo.name;
                    let userInfo = {
                        userId: userId,
                        token: token,
                        userName: userName
                    }
                    if(this.saveMe){
                        Cookies.set("BSG-savePassword",{
                            phone: this.params.phone,
                            password: this.params.password
                        },{ expires: 30 })
                    }else {
                        Cookies.remove("BSG-savePassword")
                    }
                    this.upDateUserInfo(userInfo);
                    this.$emit('update:showLogin',false);
                    Cookies.set("BSG-userInfo",{
                        userId:userId,
                        token:token,
                        userName:userName
                    })
                }
            })
        }
    }
}

</script>
<style lang="less" scoped>
    #login {
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 1000;
        background-color: rgba(0, 0, 0, 0.65);
        .content {
            width: 500px;
            height: 250px;
            background-color: #ffffff;
            border: 1px solid #ebedf0;
            border-radius: 4px;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
            position: absolute;
            top: calc(35% - 125px);
            left: calc(50% - 250px);
            z-index: 1000;
            padding-top: 40px;
            &.active {
                height: 500px;
                top: calc(40% - 250px);
            }
            .password-row {
                margin-bottom: 5px;
            }
            .close {
                font-size: 20px;
                position: absolute;
                top: 10px;
                right: 20px;
            }
            .uuid-img {
                display: block;
                width: 150px;
                height: 150px;
                margin-left: 182px;
            }
            .save-me {
                margin-left: 145px;
                margin-bottom: 10px;
                color: rgba(0, 0, 0, 0.85);
                // font-weight: bolder;
            }
            .tips {
                text-align: center;
                color: rgba(0, 0, 0, 0.45);
            }
        }
    }
</style>